import React, { useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function TicketsCategory() {
  const [filter, setFilter] = useState("Monthly");

  const dataMap = {
    Monthly: [485, 342, 268, 195, 412, 145],
    Weekly: [200, 150, 120, 100, 180, 90],
    Today: [120, 100, 80, 60, 110, 50],
  };

  const labels = [
    "IT Support",
    "HR",
    "Payroll",
    "Access",
    "Hardware",
    "Other",
  ];

  const colors = [
    "#f97316", // orange
    "#6b7280", // grey
    "#22c55e", // green
    "#eab308", // yellow
    "#f59e0b", // orange-yellow (no blue)
    "#ef4444", // red
  ];

  const data = dataMap[filter];

  return (
    <Card className="tickets-card h-100">
      <Card.Body>

        {/* HEADER */}
        <div className="tickets-header">
          <h6 className="title">Tickets By Category</h6>

          <div className="dropdown-box">
            <FiCalendar />
            <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              <option>Today</option>
              <option>Weekly</option>
              <option>Monthly</option>
            </select>
          </div>
        </div>

        {/* CHART */}
        <Chart
          type="donut"
          height={270}   // 🔥 increased height
          width="100%"
          series={data}
          options={{
            labels,
            colors,

            plotOptions: {
              pie: {
                startAngle: -90,
                endAngle: 90,
               //  offsetY: 20,
                expandOnClick: false,
                donut: {
                  size: "60%", // 🔥 thick arcs
                  labels: {
                    show: true,
                    total: {
                      show: true,
                      label: "Compliance",
                      fontSize: "14px",
                      color: "#6b7280",
                    },
                  },
                },
              },
            },

            stroke: {
              width: 8, // 🔥 spacing between segments
              colors: ["#fff"],
            },

            dataLabels: { enabled: false },
            legend: { show: false },

            tooltip: {
              custom: function ({ series, seriesIndex }) {
                const value = series[seriesIndex];

                return `
                  <div style="
                    background:#111827;
                    color:#fff;
                    padding:10px 14px;
                    border-radius:10px;
                    font-size:13px;
                  ">
                    <div style="font-weight:600;margin-bottom:4px;">
                      ${labels[seriesIndex]}
                    </div>
                    ${labels[seriesIndex]}: ${value}
                  </div>
                `;
              },
            },
          }}
        />

        {/* GRID */}
        <div className="tickets-grid">
          {labels.map((label, i) => (
            <div key={i} className="grid-item">
              <div
                className="line"
                style={{ background: colors[i] }}
              ></div>

              <div>
                <div className="name">{label}</div>
                <div className="value">{data[i]}</div>
              </div>
            </div>
          ))}
        </div>

      </Card.Body>

      {/* INTERNAL CSS */}
      <style>{`
        .tickets-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
          padding: 12px;
        }

        .tickets-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          // margin-bottom: 10px;
          flex-wrap: wrap;
          gap: 10px;
        }

        .title {
          font-weight: 600;
          font-size: 16px;
        }

        .dropdown-box {
          display: flex;
          align-items: center;
          gap: 6px;
          border: 1px solid #e5e7eb;
          padding: 6px 10px;
          border-radius: 8px;
          background: #fff;
        }

        .dropdown-box select {
          border: none;
          outline: none;
          font-size: 13px;
          background: transparent;
        }

        .tickets-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 16px;
         
        }

        .grid-item {
          display: flex;
          align-items: center;
          gap: 10px;
          justify-content: center;
        }

        .line {
          width: 3px;
          height: 40px;
          border-radius: 2px;
        }

        .name {
          font-size: 13px;
          color: "#6b7280";
        }

        .value {
          font-weight: 600;
          font-size: 16px;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .tickets-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .title {
            font-size: 14px;
          }
        }
      `}</style>
    </Card>
  );
}